export default "__VITE_ASSET__BNuQv3UE__"